import { storageGetItem, storageRemoveItem, storageSetItem } from "@/Common/helpers/Storage";
import { IUser } from "@/Common/interfaces/user";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const localStorageUserString = storageGetItem("loggedUser");
let user: IUser | null = null;
if (localStorageUserString) {
	user = localStorageUserString as IUser;
}

const initialState = {
	user,
};

export const User = createSlice({
	initialState,
	name: "user",
	reducers: {
		SET_USER: (state, { payload }: PayloadAction<{ user: Partial<IUser> | null }>) => {
			if (payload.user) {
				const updatedUser = { ...state.user, ...payload.user };
				const dashboardLayout = updatedUser.dashboardLayout;
				storageSetItem("loggedUser", updatedUser);
				if (dashboardLayout) {
					storageSetItem("dashboard-layout", dashboardLayout);
				}
				state.user = updatedUser;
			} else {
				storageRemoveItem("loggedUser");
				state.user = null;
			}
		},
		SET_USER_ACTIONS: (
			state,
			{
				payload,
			}: PayloadAction<{
				actions: IUser["actions"];
			}>
		) => {
			if (state.user && payload.actions) {
				state.user.actions = payload.actions;
				storageSetItem("loggedUser", state.user);
			}
		},
	},
});

export const { actions } = User;
export default User.reducer;
